<template ref="form">
    <div>
        <h1 class="title is-3">
            {{ isClone ? 'Clone' : item.id ? 'Update' : 'Create' }} proposal
        </h1>

        <o-tabs v-model="tabIndex" type="is-boxed">
            <o-tab-item :value="0" label="Select Property">
                <form class="is-clearfix">
                    <div class="columns">
                        <div class="column">
                            <o-field>
                                <template #label>
                                    Proposal Number <span style="color: red">*</span>
                                </template>
                                <o-input v-model="copy.number" disabled
                                    placeholder="Proposal Number will be autogenerated" />
                            </o-field>

                            <o-field label="Project Name" :type="fieldType('project_name')"
                                :message="getError('project_name')">
                                <template #label>
                                    Project Name <span style="color: red">*</span>
                                </template>
                                <o-input v-model="copy.project_name" />
                            </o-field>

                            <div class="field">
                                <o-checkbox v-model="copy.notable">
                                    Notable
                                </o-checkbox>
                            </div>

                            <div class="between-center">
                                <o-field label="Company" style="flex: 1" :type="fieldType('company_id')"
                                    :message="getError('company_id')">
                                    <template #label>
                                        Company <span style="color: red">*</span>
                                    </template>
                                    <autocomplete-select v-model="copy.company_id" type="company"
                                        placeholder="Select a Companies" track="id" field-name="name"
                                        :value="companyById(copy.company_id)" />
                                </o-field>

                                <div class="field" style="margin: 12px 10px 0">
                                    <a style="width: 170px" class="button is-primary"
                                        @click.prevent="openNewCompanyModal('company_id')">Add
                                        Company</a>
                                </div>
                            </div>

                            <div class="between-center">
                                <o-field label="Contacts" style="flex: 1" :type="fieldType('contacts')"
                                    :message="getError('contacts')">
                                    <template #label>
                                        Contacts <span style="color: red">*</span>
                                    </template>
                                    <multicomplete ref="contacts" v-model="copy.contacts" type="company_contacts"
                                        placeholder="Select Contacts" field-name="full_name" track="id" :limit="99"
                                        :disabled="!copy.company_id" :value="item.contacts"
                                        :options-prop2="copy.company_id" />
                                </o-field>
                                <div class="field" style="margin: 15px 0 0 10px">
                                    <button :disabled="!copy.company_id" style="width: 170px" class="button is-primary"
                                        @click.prevent="openNewContactModal(copy.company_id, 'contact_id')">
                                        Add Contact
                                    </button>
                                </div>
                            </div>

                            <o-field label="Created By" :type="fieldType('created_by')"
                                :message="getError('created_by')">
                                <template #label>
                                    Created By <span style="color: red">*</span>
                                </template>
                                <autocomplete-select v-model="copy.created_by" type="user" placeholder="Select a User"
                                    track="id" field-name="full_name" :value="userById(copy.created_by)" />
                            </o-field>

                            <o-field label="Borough" :type="fieldType('borough')" :message="getError('borough')">
                                <template #label>
                                    Borough <span style="color: red">*</span>
                                </template>
                                <o-select v-model="copy.borough" placeholder="Select a borough" expanded>
                                    <option v-for="borough in boroughs" :key="borough.id" :value="borough.id">
                                        {{ borough.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <div class="columns">
                                <div class="column">
                                    <o-field label="Building Number" :type="fieldType('building')"
                                        :message="getError('building')">
                                        <template #label>
                                            Building Number <span style="color: red">*</span>
                                        </template>
                                        <o-input v-model="copy.building" />
                                    </o-field>
                                </div>
                                <div class="column">
                                    <o-field label="Street" :type="fieldType('street')" :message="getError('street')">
                                        <template #label>
                                            Street <span style="color: red">*</span>
                                        </template>
                                        <o-input v-model="copy.street" />
                                    </o-field>
                                </div>
                            </div>

                            <div>
                                <label class="label">Terms and Conditions <span style="color: red">*</span>
                                </label>
                                <!--                              <b-quill v-model="copy.terms_and_conditions" :error="getError('terms_and_conditions')" />-->
                                <quill-editor :content="copy.terms_and_conditions" content-type="html" theme="snow" />
                            </div>
                            <p class="help is-info">
                                [retainer_amount] will be replaced with Grand Total * Deposit Percent
                            </p>
                        </div>

                        <div class="column">
                            <o-field label="Sales Person" :type="fieldType('sales_id')" :message="getError('sales_id')">
                                <autocomplete-select v-model="copy.sales_id" track="id" field-name="full_name"
                                    placeholder="Select a User" type="user" :value="userById(copy.sales_id)" />
                            </o-field>

                            <div class="between-center">
                                <o-field label="Billed to Company" style="flex: 1" :type="fieldType('company')"
                                    :message="getError('company')">
                                    <template #label>
                                        Billed to Company <span style="color: red">*</span>
                                    </template>
                                    <autocomplete-select ref="billed_company" v-model="copy.billed_to_company"
                                        type="company" :disabled="isBilledToCompanyDisabled" track="id"
                                        placeholder="Select a Companies" field-name="name"
                                        :value="companyById(copy.billed_to_company)" :is-object="true" />
                                </o-field>


                                <div class="field" style="margin: 20px 0 0 10px">
                                    <a style="width: 170px" class="button is-primary"
                                        @click.prevent="openNewCompanyModal('billed_to_company')">Add Company</a>
                                </div>
                            </div>
                            <div class="field">
                                <div class="form-check">
                                    <input id="flexCheckChecked" class="form-check-input" type="checkbox" value=""
                                        :disabled="!copy.company_id" @change="onCheck">
                                    <label class="form-check-label" for="flexCheckChecked">
                                        Same as main company
                                    </label>
                                </div>
                            </div>

                            <div class="between-center">
                                <o-field label="Billed to Contacts" style="flex: 1"
                                    :type="fieldType('billed_to_contacts')" :message="getError('billed_to_contacts')">
                                    <template #label>
                                        Billed to Contacts <span style="color: red">*</span>
                                    </template>
                                    <multicomplete ref="billed_contacts" v-model="copy.billed_to_contacts"
                                        type="company_contacts" placeholder="Select Contacts" field-name="full_name"
                                        track="id" :limit="99" :value="item.billed_to_contacts"
                                        :disabled="isBilledToContactsDisabled"
                                        :options-prop2="copy.billed_to_company" />
                                </o-field>
                                <div class="field" style="margin: 15px 0 0 10px">
                                    <button :disabled="!copy.billed_to_company" style="width: 170px"
                                        class="button is-primary"
                                        @click.prevent="openNewContactModal(copy.billed_to_company, 'billed_to_contact')">
                                        Add Contact
                                    </button>
                                </div>
                            </div>
                            <div class="field">
                                <div class="form-check">
                                    <input id="flexCheckChecked2" class="form-check-input" type="checkbox" value=""
                                        :disabled="isMainContactCheckboxDisabled" @change="onCheck2">
                                    <label class="form-check-label" for="flexCheckChecked2">
                                        Same as main contact
                                    </label>
                                </div>
                            </div>

                            <o-field label="Deposit %" :type="fieldType('deposit_percent')"
                                :message="getError('deposit_percent')">
                                <o-input v-model="copy.deposit_percent" :disabled="copy.pay_in_full" />
                            </o-field>

                            <div class="field">
                                <o-checkbox v-model="copy.pay_in_full">
                                    Pay In Full
                                </o-checkbox>
                            </div>

                            <o-field label="Floor Number" :type="fieldType('floor_number')"
                                :message="getError('floor_number')">
                                <o-input v-model="copy.floor_number" />
                            </o-field>

                            <o-field label="Status" :type="fieldType('status')" :message="getError('status')">
                                <template #label>
                                    Status <span style="color: red">*</span>
                                </template>
                                <o-select v-model="copy.status" placeholder="Select a status" expanded>
                                    <option v-for="status in proposalStatuses" :key="status.id" :value="status.id">
                                        {{ status.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <o-field label="Type of Project" :type="fieldType('project_type')"
                                :message="getError('project_type')">
                                <template #label>
                                    Type of Project <span style="color: red">*</span>
                                </template>
                                <o-select v-model="copy.project_type" placeholder="Select a Type of Project" expanded>
                                    <option v-for="projectType in projectTypes" :key="projectType.id"
                                        :value="projectType.id">
                                        {{ projectType.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <o-field label="Date Created">
                                <template #label>
                                    Date Created <span style="color: red">*</span>
                                </template>
                                <datepicker :is-time-picker="false" :error="getError('date_created')"
                                    :value="copy.date_created" />
                            </o-field>

                            <o-field label="Lead Source" :type="fieldType('lead_source_id')"
                                :message="getError('lead_source_id')">
                                <template #label>
                                    Lead Source <span style="color: red">*</span>
                                </template>
                                <o-select v-model="copy.lead_source_id" placeholder="Select a Lead Source" expanded>
                                    <option v-for="option in dictionaryEntriesByType('lead-source')" :key="option.name"
                                        :value="option.id">
                                        {{ option.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <o-field v-show="copy.lead_source_id == 2" label="Lead Contact">
                                <autocomplete-select v-model="copy.lead_contact_id" :show-companies="true"
                                    type="contact" track="id" placeholder="Select a contact" field-name="full_name"
                                    :value="contactById(copy.lead_contact_id)" />
                            </o-field>

                            <o-field label="Remind By" :type="fieldType('remind_by')" :error="getError('remind_by')">
                                <datepicker v-model="copy.remind_by" :is-time-picker="false" :config="config"
                                    placeholder="Select a date" :error="getError('remind_by')" />
                            </o-field>

                            <button v-if="item.id" class="button is-warning is-small"
                                @click.prevent="isReminderModalActive = true">
                                Set Reminder
                            </button>
                        </div>
                    </div>

                    <div class="field is-grouped is-pulled-right">
                        <p class="control">
                            <router-link :to="{ name: 'proposals.index' }" class="button">
                                Cancel
                            </router-link>
                        </p>
                        <p class="control">
                            <button class="button is-primary" @click.prevent="goToTab(1)">
                                Continue
                            </button>
                        </p>
                        <p v-if="!item.project_id && dictionariesLoaded" class="control">
                            <button id="btn_save" v-submit="submitting" class="button is-success"
                                @click.prevent="handleCreateOrUpdate(false)">
                                Save
                            </button>
                        </p>
                        <p v-if="!item.project_id && dictionariesLoaded" class="control">
                            <button id="btn_save" v-submit="submitting" class="button is-success"
                                @click.prevent="handleSaveAndPreview(true)">
                                Save & Preview
                            </button>
                        </p>
                    </div>
                </form>

                <o-modal v-model:active="isCompanyModalActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
                    has-modal-card>
                    <company-modal @company-added="selectCompany" />
                </o-modal>

                <o-modal v-model:active="isContactModalActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
                    has-modal-card>
                    <contact-modal :item="{ company_id: newContactCompanyId }" :quick-add="true"
                        @contact-added="selectContact" />
                </o-modal>
            </o-tab-item>

            <o-tab-item :value="1" label="Initial Services">
                <project-services-initial v-if="dictionariesLoaded" v-model="selectedServicesContainSubServices"
                    :source-id="proposalId" source-type="proposal" :secondary-tab-index="secondaryTabIndex"
                    @secondary-tab-changed="secondaryTabIndex = $event" />

                <div class="field is-grouped is-pulled-right">
                    <p class="control">
                        <router-link :to="{ name: 'proposals.index' }" class="button">
                            Cancel
                        </router-link>
                    </p>
                    <p class="control">
                        <button class="button is-dark" @click.prevent="goToTab(0)">
                            Back
                        </button>
                    </p>
                    <p class="control">
                        <button class="button is-primary" @click.prevent="goToTab(2)">
                            Continue
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleCreateOrUpdate(false)">
                            Save
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleSaveAndPreview(true)">
                            Save & Preview
                        </button>
                    </p>
                </div>
            </o-tab-item>

            <o-tab-item :value="2" label="Optional Services">
                <project-services-optional v-if="dictionariesLoaded" :source-id="proposalId" source-type="proposal" />

                <div class="field is-grouped is-pulled-right">
                    <p class="control">
                        <router-link :to="{ name: 'proposals.index' }" class="button">
                            Cancel
                        </router-link>
                    </p>
                    <p class="control">
                        <button class="button is-dark" @click.prevent="goToTab(1)">
                            Back
                        </button>
                    </p>
                    <p class="control">
                        <button class="button is-primary" @click.prevent="goToTab(3)">
                            Continue
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleCreateOrUpdate(false)">
                            Save
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleSaveAndPreview(true)">
                            Save & Preview
                        </button>
                    </p>
                </div>
            </o-tab-item>

            <o-tab-item :value="3" label="Pricing/Quantities">
                <pricing v-if="dictionariesLoaded" ref="pricing" :proposal-id="proposalId" />

                <div class="field is-grouped is-pulled-right">
                    <p class="control">
                        <router-link :to="{ name: 'proposals.index' }" class="button">
                            Cancel
                        </router-link>
                    </p>
                    <p class="control">
                        <button class="button is-dark" @click.prevent="goToTab(2)">
                            Back
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleCreateOrUpdate(true)">
                            Save
                        </button>
                    </p>
                    <p v-if="item.project_id" class="control">
                        <button disabled class="button is-success">
                            Converted
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleSaveAndConvert(true)">
                            Save and Convert
                        </button>
                    </p>
                    <p v-if="!item.project_id" class="control">
                        <button id="btn_save" v-submit="submitting" class="button is-success"
                            @click.prevent="handleSaveAndPreview(true)">
                            Save & Preview
                        </button>
                    </p>
                </div>
            </o-tab-item>
        </o-tabs>
        <o-modal :active="isReminderModalActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
            has-modal-card>
            <reminder-modal :reference-id="item.id" reference-type="proposal" />
        </o-modal>
        <o-modal :active="isPreviewModalActive" :can-cancel="['escape', 'outside', 'button']" scroll="keep"
            class="preview-modal" has-modal-card @close="previewModalCloseHandler">
            <preview-modal :action-button="actionButton" :file="currentPreviewFile" />
        </o-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Datepicker from './../../components/Datepicker'
import HandlesForm from './../../mixins/HandlesForm'

import CompanyModal from './../../components/modals/Company'
import ContactModal from './../../components/modals/Contact'

import { QuillEditor } from "@vueup/vue-quill"
import ProjectServicesInitial from '../../components/ProjectServicesInitial'
import ProjectServicesOptional from '../../components/ProjectServicesOptional'
import PreviewModal from './../../components/modals/Preview'
import Pricing from './form/PricingQuantities'

const contactTypes = { billed_to_contacts: 'billed_to_contact', contacts: 'contact_id' }
const contactTypesKeys = Object.keys(contactTypes)

export default {
    name: 'ProposalForm',

    components: {
        QuillEditor,
        Datepicker,
        CompanyModal,
        ContactModal,
        PreviewModal,
        Pricing,
        ProjectServicesInitial,
        ProjectServicesOptional
    },
    mixins: [HandlesForm],

    props: {
        isClone: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            billed_to_contacts: [],
            contacts: [],
            companyContacts: [],
            billedContacts: [],
            currentPreviewFile: null,
            loadingContacts: false,
            loadingBilledToContacts: false,
            tabIndex: 0,
            secondaryTabIndex: 0,
            isBilledToCompanyDisabled: false,
            isBilledToContactsDisabled: false,

            selectedServicesContainSubServices: false,

            newContactCompanyId: null,

            isCompanyModalActive: false,
            isContactModalActive: false,
            isPreviewModalActive: false,
            isReminderModalActive: false,

            companyTypeToAdd: null,
            contactTypeToAdd: null,
            config: {
                minDate: 'today'
            },
            redirectBack: false,
        }
    },

    computed: {
        ...mapGetters([
            'allUsers',
            'boroughs',
            'contactById',
            'proposalStatuses',
            'projectTypes',
            'permitTypes',
            'jobWorkTypes',
            'companies',
            'contactsByCompanyId',
            'dictionariesLoaded',
            'projectInitialServicesBySource',
            'serviceById',
            'dictionaryEntriesByType',
            'defaultProposalStatus',
            'companyById',
            'userById',
            'allUsers'
        ]),

        actionButton() {
            const vm = this
            if (!!vm.copy.sent_at) { return null }
            return {
                label: 'Send to customer',
                handler() {
                    vm.openMessageModal({ entity: vm.copy, entity_type: 'proposal', context: 'proposal-request-signature-message' })
                    vm.previewModalCloseHandler()
                }
            }
        },

        selected: {
            get() {
                return this.contactdata
            },
            set(value) {
                console.log(value)
                return this.this.contactdata.push(value)
            }
        },

        handleContactSelected() {
            return this.setContacts
        },

        proposalId() {
            return this.isClone ? null : this.item.id ? this.item.id : null
        },

        created_at() {
            let date = this.copy.created_at ? moment(this.copy.created_at) : moment()

            return date.format('MM/DD/YYYY')
        },

        isMainContactCheckboxDisabled() {
            return !this.copy.billed_to_company || !this.copy.contacts || this.copy.contacts.length === 0
        },

        billedToCompanySameAsCompany: {
            get() {
                if (this.copy.billed_to_company || this.copy.company_id) {
                    return this.copy.billed_to_company === this.copy.company_id
                }

                return false
            },
            set(value) {
                console.log(value)
                if (value) {
                    this.copy.billed_to_company = this.copy.company_id
                }
            }
        },

        billedToContactsSameAsContacts: {
            get() {
                let btc = this.copy.billed_to_contacts, c = this.copy.contacts
                return !!btc && !!c && btc.length === c.length && btc.join() === c.join()
            },
            set(value) {
                console.log(value)
                if (value) {
                    this.setContacts('billed_to_contacts', this.copy)
                }
            }
        },
    },


    beforeUnmount() {
        this.clearProjectServices()
    },

    methods: {
        ...mapActions(['createOrUpdateProposal', 'clearProjectServices', 'convertProposal', 'fetchContacts', 'openMessageModal', 'fetchCompanies']),

        onCheck(e) {
            if (e.target.checked && this.copy.billed_to_company || this.copy.company_id) {
                this.copy.billed_to_company = this.copy.company_id
                this.$refs.billed_company.$refs.autocomplete.iv = []
                this.$refs.billed_company.$refs.autocomplete.iv = this.companyById(this.copy.company_id)
                // this.isBilledToCompanyDisabled = true
            }
            if (!e.target.checked) {
                this.copy.billed_to_company = undefined
                this.$refs.billed_company.$refs.autocomplete.iv = []
                // this.isBilledToCompanyDisabled = false
            }
        },

        onCheck2(e) {
            if (e.target.checked && this.copy.billed_to_company) {
                this.copy.billed_to_contacts = this.copy.contacts
                this.item.billed_to_contacts = this.copy.contacts

                this.$refs.billed_contacts.$refs.multicomplete.iv = []
                this.item.billed_to_contacts.map((item) => {
                    this.$refs.billed_contacts.$refs.multicomplete.iv.push(this.contactById(item))
                })
                // this.isBilledToContactsDisabled = true
            }
            else {
                this.copy.billed_to_contacts = undefined
                this.item.billed_to_contacts = undefined
                this.$refs.billed_contacts.$refs.multicomplete.iv = []
                this.isBilledToContactsDisabled = false
            }
        },

        getContacts() {
            return this.copy.contacts === null ? this.item.contacts : this.copy.contacts
        },

        getBilledContacts() {
            return this.copy.billed_to_contacts === null ? this.item.billed_to_contacts : this.copy.billed_to_contacts
        },


        handleCreateOrUpdate(redirect = true) {
            if (this.isClone) {
                this.copy.id = null;
            }
            let proposalExists = this.copy.id !== undefined
            let submit = this.wrapSubmit(this.createOrUpdateProposal)

            let projectServices = this.projectInitialServicesBySource({
                source_type: 'proposal',
                source_id: this.proposalId
            })

            for (let index in projectServices) {
                let projectService = projectServices[index]
                if (this.isClone) {
                    projectService.project_id = null
                    projectService.created_at = null
                    projectService.updated_at = null
                    projectService.status = 'draft'
                }


                let service = this.serviceById(projectService.service_id)

                if (service.work_types.length && !projectService.work_types.length) {
                    this.errorMessage('Please pick Sub Services')
                    this.tabIndex = 1

                    return new Promise((_resolve, reject) => {
                        reject()
                    })
                }
            }

            let pricing = this.$refs.pricing


            if (!pricing.validateProjectServices()) {
                return new Promise((_resolve, reject) => {
                    this.errorMessage('Please verify project services listed price, work type price, title and notation are correct')
                    this.tabIndex = 3

                    reject()
                })
            }

            return submit(this.copy)
                .then(res => {
                    let id = res.data.data.id
                    this.copy.id = id

                    !this.isClone && proposalExists ?
                        this.successMessage('Proposal has been updated') :
                        this.successMessage('Proposal has been created')

                    if (this.isClone) {
                        this.$router.push(`/proposals`)
                    } else {
                        if (redirect) {
                            // if (redirectBack && proposalExists) {
                            //     // this.$router.push(`/proposals/${id}`)
                            //     // this.$router.push(`/proposals`)
                            // } else if (! proposalExists) {
                            //     this.$router.push(`/proposals`)
                            // }
                            this.copy = {}
                            // this.$router.push(`/proposals`)
                            window.location.replace(`/proposals`)

                        }
                    }

                    return res
                })
                .catch(res => {
                    this.tabIndex = 0
                    throw res
                })
        },

        handleSaveAndConvert(redirectBack = false) {
            this.confirmMessage(
                'Save and convert',
                'Are you sure you want to <strong>Save and convert</strong> this proposal? This action cannot be undone.',
                'Save and convert',
            ).then(() => {
                this.handleCreateOrUpdate(redirectBack)
                    .then(res => {
                        this.convertProposal(res.data.data)
                            .then(res2 => {
                                if (redirectBack) {
                                    this.$router.push(`/proposals/${res.data.data.id}`)
                                    this.copy = {}
                                    return res
                                }
                                return res2
                            })
                        return res
                    })
            })
        },

        handleSaveAndPreview(redirectBack = false) {
            this.redirectBack = redirectBack
            this.handleCreateOrUpdate(false, false).then(res => {
                document.getElementById('btn_save').disabled = true
                this.openPreviewModal(res.data.data)
            })
        },

        goToTab(tabIndex) {
            if (this.tabIndex === 2 && tabIndex === 1 && this.selectedServicesContainSubServices) {
                this.secondaryTabIndex = 1
                this.tabIndex = tabIndex
            } else if (this.secondaryTabIndex === 0 && tabIndex === 2 && this.selectedServicesContainSubServices) {
                this.secondaryTabIndex = 1
            } else if (this.secondaryTabIndex === 1 && this.tabIndex === 2) {
                this.secondaryTabIndex = 0
            } else if (tabIndex === 0 && this.secondaryTabIndex === 1) {
                this.secondaryTabIndex = 0
            } else {
                this.secondaryTabIndex = 0
                this.tabIndex = tabIndex
            }

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },

        fetchCompanyContacts() {
            this.loadingContacts = true
            this.fetchContacts().then().catch().finally(() => this.loadingContacts = false)
        },

        fetchBilledToCompanyContacts() {
            this.fetchContacts()
        },

        openNewContactModal(companyId, contactType) {
            // Always store the company for the modal; contactTypeToAdd drives
            // which field gets updated in selectContact after saving.
            this.newContactCompanyId = companyId
            this.contactTypeToAdd = contactType
            this.isContactModalActive = true
        },

        openNewCompanyModal(companyType) {
            this.companyTypeToAdd = companyType
            this.isCompanyModalActive = true
        },

        openPreviewModal(proposal) {
            const port = window.location.port ? `:${window.location.port}` : '';
            this.currentPreviewFile = {
                name: `Proposal #${proposal.number}`,
                mime: 'application/pdf',
                path: `${window.location.protocol}//${window.location.hostname}${port}/proposals/${proposal.id}/pdf`,
                generatedOnTheFly: true
            }
            this.isPreviewModalActive = true
        },

        previewModalCloseHandler() {
            const proposalExists = !!this.proposalId
            const id = this.copy.id
            if (this.redirectBack && proposalExists) {
                this.$router.push(`/proposals/${id}`)
            } else if (!proposalExists) {
                this.$router.push(`/proposals`)
            }
        },

        selectCompany(companyId) {
            this.copy[this.companyTypeToAdd || 'company_id'] = companyId
        },

        selectContact(contactId) {
            this.fetchContacts({ id: contactId })

            if (this.contactTypeToAdd === 'billed_to_contact' && this.$refs.billed_contacts?.$refs?.multicomplete?.iv) {
                this.$refs.billed_contacts.$refs.multicomplete.iv = []
                this.$refs.billed_contacts.$refs.multicomplete.iv.push(this.contactById(contactId))
                this.copy.billed_to_contact = contactId
                this.copy.billed_to_contacts = [contactId]
            } else {
                this.$refs.contacts.$refs.multicomplete.iv = []
                this.$refs.contacts.$refs.multicomplete.iv.push(this.contactById(contactId))
                this.copy.contact_id = contactId
                this.copy.contacts = [contactId]
            }
        },

        setContacts(type, data) {
            if (!contactTypesKeys.includes(type)) { return }
            // get id from array
            this.copy[type] = _.map(data, 'id')
        }
    },

    mounted() {
        if (!this.item.company_id) {
            this.copy.company_id = parseInt(this.$route.query.company_id)
        }

        console.log(this.$refs);
        

        this.fetchCompanies({ id: this.item.company_id })
        this.fetchCompanies({ id: this.item.billed_to_company })

        this.setContacts('contacts', this.copy.contacts)
        this.setContacts('billed_to_contacts', this.copy.billed_to_contacts)

        if (!this.proposalId) {
            this.copy.status = this.defaultProposalStatus.id
        }

        this.fetchCompanyContacts()
        this.fetchBilledToCompanyContacts()
    },
}
</script>

<style>
.inline-toolbar {
    display: block;
}
</style>
